export const lightColors = {
  // Primary Brand Colors (same)
  deepTrustBlue: '#0052CC',
  honestTeal: '#00BFA6',

  // Background (light)
  warmGray: '#FFFFFF',
  white: '#F8F9FA',

  // Text (inverted for light mode)
  slateCharcoal: '#1F2933',
  steelGray: '#4B5563',

  // ReactBits-inspired text colors (in light mode, these are darker for contrast)
  softWhite: '#1F2933',  // In light mode, use dark text
  mutedWhite: '#374151',

  // Status Colors (same)
  insightOrange: '#FF8C42',
  truthGreen: '#28A745',
  cautionRed: '#E63946',

  // Neutrals (adjusted for light)
  lightGray: '#E5E7EB',
  borderGray: '#D1D5DB',
  hintGray: '#9CA3AF',

  // Gradients
  gradients: {
    trustBloom: 'linear-gradient(90deg, #0052CC 0%, #00BFA6 100%)',
    progressPop: 'linear-gradient(90deg, #00BFA6 0%, #FF8C42 100%)',
    darkOverlay: 'linear-gradient(135deg, rgba(0,82,204,0.05) 0%, rgba(0,191,166,0.03) 100%)',
  }
};
